import { css } from '@emotion/core';
export var listingImage = {
  name: "ohwg9z",
  styles: "position:relative;overflow:hidden;"
};